// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BookingForm-needFormCardFlex-yjKsl {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    gap: 6px;
    grid-gap: 6px;
    padding: 18px;
    border: 1px solid var(--primary-border);
    border-radius: var(--radius-2);
}

.BookingForm-needFormCardImgContainer-MxCAk {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: baseline;
        -ms-flex-align: baseline;
            align-items: baseline;
    -webkit-box-pack: start;
        -ms-flex-pack: start;
            justify-content: flex-start;
    gap: 6px;
    grid-gap: 6px;
    width: 100%;
    -webkit-box-flex: 1;
        -ms-flex-positive: 1;
            flex-grow: 1;
    text-align: start;
}

.BookingForm-needFormCardImgContainer-MxCAk img {
    position: relative;
    top: 3px;
}

.BookingForm-needFormCardContainer-NWjjQ {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
    gap: 18px;
    grid-gap: 18px;
}`, "",{"version":3,"sources":["webpack://./src/components/BookingForm/BookingForm.css"],"names":[],"mappings":"AAAA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAA8B;QAA9B,sBAA8B;YAA9B,8BAA8B;IAC9B,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,QAAQ;IACR,aAAa;IACb,aAAa;IACb,uCAAuC;IACvC,8BAA8B;AAClC;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,2BAAqB;QAArB,wBAAqB;YAArB,qBAAqB;IACrB,uBAA2B;QAA3B,oBAA2B;YAA3B,2BAA2B;IAC3B,QAAQ;IACR,aAAa;IACb,WAAW;IACX,mBAAY;QAAZ,oBAAY;YAAZ,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;IACtB,SAAS;IACT,cAAc;AAClB","sourcesContent":[".needFormCardFlex {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 6px;\n    grid-gap: 6px;\n    padding: 18px;\n    border: 1px solid var(--primary-border);\n    border-radius: var(--radius-2);\n}\n\n.needFormCardImgContainer {\n    display: flex;\n    align-items: baseline;\n    justify-content: flex-start;\n    gap: 6px;\n    grid-gap: 6px;\n    width: 100%;\n    flex-grow: 1;\n    text-align: start;\n}\n\n.needFormCardImgContainer img {\n    position: relative;\n    top: 3px;\n}\n\n.needFormCardContainer {\n    display: flex;\n    flex-direction: column;\n    gap: 18px;\n    grid-gap: 18px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"needFormCardFlex": `BookingForm-needFormCardFlex-yjKsl`,
	"needFormCardImgContainer": `BookingForm-needFormCardImgContainer-MxCAk`,
	"needFormCardContainer": `BookingForm-needFormCardContainer-NWjjQ`
};
module.exports = ___CSS_LOADER_EXPORT___;
